import React from 'react';

const OppositionLink = ({ opposition, url }) => {
    if (url) {
        return (
            <a href={url} target="_new">
                {opposition}
            </a>
        );
    }
    return <span>{opposition}</span>;
};

export default OppositionLink;



// WEBPACK FOOTER //
// ./src/components/OppositionLink.jsx